var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrabIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.648438 6C0.648438 2.68629 3.33473 0 6.64844 0H24.6484C27.9621 0 30.6484 2.68629 30.6484 6V24C30.6484 27.3137 27.9621 30 24.6484 30H6.64844C3.33473 30 0.648438 27.3137 0.648438 24V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6484 14C11.0962 14 10.6484 13.5523 10.6484 13C10.6484 12.4477 11.0962 12 11.6484 12C12.2007 12 12.6484 12.4477 12.6484 13C12.6484 13.5523 12.2007 14 11.6484 14Z",
    fill: "#494949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6484 13C14.6484 13.5523 15.0962 14 15.6484 14C16.2007 14 16.6484 13.5523 16.6484 13C16.6484 12.4477 16.2007 12 15.6484 12C15.0962 12 14.6484 12.4477 14.6484 13Z",
    fill: "#494949"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6484 13C18.6484 13.5523 19.0962 14 19.6484 14C20.2007 14 20.6484 13.5523 20.6484 13C20.6484 12.4477 20.2007 12 19.6484 12C19.0962 12 18.6484 12.4477 18.6484 13Z",
    fill: "#494949"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6484 17C18.6484 17.5523 19.0962 18 19.6484 18C20.2007 18 20.6484 17.5523 20.6484 17C20.6484 16.4477 20.2007 16 19.6484 16C19.0962 16 18.6484 16.4477 18.6484 17Z",
    fill: "#494949"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6484 18C15.0962 18 14.6484 17.5523 14.6484 17C14.6484 16.4477 15.0962 16 15.6484 16C16.2007 16 16.6484 16.4477 16.6484 17C16.6484 17.5523 16.2007 18 15.6484 18Z",
    fill: "#494949"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6484 17C10.6484 17.5523 11.0962 18 11.6484 18C12.2007 18 12.6484 17.5523 12.6484 17C12.6484 16.4477 12.2007 16 11.6484 16C11.0962 16 10.6484 16.4477 10.6484 17Z",
    fill: "#494949"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64844 1H24.6484V-1H6.64844V1ZM29.6484 6V24H31.6484V6H29.6484ZM24.6484 29H6.64844V31H24.6484V29ZM1.64844 24V6H-0.351562V24H1.64844ZM6.64844 29C3.88701 29 1.64844 26.7614 1.64844 24H-0.351562C-0.351562 27.866 2.78244 31 6.64844 31V29ZM29.6484 24C29.6484 26.7614 27.4099 29 24.6484 29V31C28.5144 31 31.6484 27.866 31.6484 24H29.6484ZM24.6484 1C27.4099 1 29.6484 3.23858 29.6484 6H31.6484C31.6484 2.13401 28.5144 -1 24.6484 -1V1ZM6.64844 -1C2.78244 -1 -0.351562 2.13401 -0.351562 6H1.64844C1.64844 3.23858 3.88701 1 6.64844 1V-1Z",
    fill: "#DADEE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrabIcon);
export default __webpack_public_path__ + "static/media/grab-icon.1144444b3c1a19298e80cdaca8b58abe.svg";
export { ForwardRef as ReactComponent };